import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

export const openInAppBrowser = async (url: string) => {
  if (Capacitor.isNativePlatform()) {
    try {
      await Browser.open({
        url: url,
        windowName: '_blank',
        toolbarColor: '#000000',
        presentationStyle: 'fullscreen',
      });
    } catch (error) {
      console.error('Browser error:', error);
      // Fallback to system browser if in-app fails
      window.open(url, '_system');
    }
  } else {
    // Web fallback
    window.open(url, '_blank');
  }
};
